import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import LanguageToggle from "./LanguageToggle";
import { BrandMark } from "./Logo";

export default function MarketingNav() {
  const { t } = useI18n();
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-50 glass border-b border-white/10">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" className="group" data-testid="brand-link">
          <BrandMark />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <a href="#features" className="text-slate-300 hover:text-white transition" data-testid="nav-features">{t("nav.features")}</a>
          <a href="#pricing" className="text-slate-300 hover:text-white transition" data-testid="nav-pricing">{t("nav.pricing")}</a>
        </nav>
        <div className="flex items-center gap-3">
          <LanguageToggle />
          {user ? (
            <Link to="/app/dashboard" className="btn-primary text-sm" data-testid="nav-dashboard">{t("nav.dashboard")}</Link>
          ) : (
            <>
              <Link to="/login" className="hidden sm:inline-flex text-sm text-slate-300 hover:text-white transition" data-testid="nav-login">{t("nav.login")}</Link>
              <Link to="/signup" className="btn-primary text-sm" data-testid="nav-signup">{t("nav.signup")}</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
